<auto-main-navigation [accountId]="accountId"></auto-main-navigation>

<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">Inventory Settings</h1>
  </p-header>
  <div class="main-content-wrapper p-grid">
    <div class="p-col-3">
      <p-panelMenu [model]="settingsSideNav">
      </p-panelMenu>
    </div>
    <p-panel class="p-col ad-types-wrapper">
      <p-header class="mapping-rules-header-wrapper">
        <h2 class="ad-types-header-text">Inventory Mapping</h2>
      </p-header>
      <div class="reset-update-mapping-header">
        <p-button label="Save"
                  [disabled]="duplicateFields.size > 0 || (inventoryMappingForm && !inventoryMappingForm.dirty)"
                  (click)="updateInventoryMapping()"
                  styleClass="p-button-success p-button-icon"
                  class="update-mapping-button">
        </p-button>
      </div>
      <p-confirmDialog></p-confirmDialog>
      <div [formGroup]="inventoryMappingForm" *ngIf="isFieldLoaded">
        <div formArrayName="fields">
          <tr class="p-grid p-justify-even form row">
            <th class="p-col-3">Offer Field</th>
            <th class="p-col-3">Column Name</th>
            <th class="p-col-2">Is Multi Value</th>
            <th class="p-col-2">Separator</th>
            <th class="p-col-1"></th>
          </tr>
          <br>
          <div class="p-grid inventory-field p-justify-even form row" autoTrackUnsavedChanges
               *ngFor="let field of fields.controls; let idx = index" [formGroupName]="idx">
            <td class="p-col-3 center-aligned-content position-relative custom-dropdown">
              <div>
                <p-dropdown [options]="getFilteredOfferFieldOptions(field.get('name').value)"
                            formControlName="name"
                            placeholder="Select an Option"
                            pTooltip="Required Field"
                            (onChange)="hasDuplicateField()"
                            tooltipPosition="top"
                            [tooltipDisabled]="!isRequiredField(field.get('name').value)"
                            class="dropdown">
                </p-dropdown>
                <div *ngIf="duplicateFields.has(idx)" class="input-validation-wrapper">
                  <small class="p-d-block p-error">Duplicate Offer Field Found</small>
                </div>
              </div>
            </td>
            <td class="p-col-3 center-aligned-content position-relative custom-dropdown">
              <p-dropdown
                [options]="inventoryHeaders"
                formControlName="inventoryHeader"
                placeholder="Select an Option"
                class="dropdown">
              </p-dropdown>
            </td>
            <td class="p-col-2 center-aligned-content position-relative">
              <p-checkbox binary="true" formControlName="isMultiValue"></p-checkbox>
            </td>
            <td class="p-col-2 center-aligned-content position-relative">
              <p-dropdown [options]="separators" formControlName="multiValueSeparator"
                          *ngIf="field.get('isMultiValue').value"></p-dropdown>
            </td>
            <td class="p-col-1 center-aligned-content position-relative">
              <button *ngIf="!isRequiredField(field.get('name').value)"
                      pButton type="button"
                      (click)="deleteMappingField(idx)"
                      [disabled]="requestProcessing"
                      class="p-button-danger p-button-icon">
                <i class="pi pi-trash"></i>
              </button>
            </td>
            <p-scrollTop/>
          </div>
          <div class="add-new-field-button">
            <p-button
              label="Add New Field"
              class="new-field-button"
              (click)="addInventoryMapping()"
              [disabled]="requestProcessing"
              styleClass="p-button-secondary p-button-icon">
            </p-button>
          </div>
          <div class="reset-update-mapping-header">
            <p-button
              class="reset-to-default-button"
              [disabled]="requestProcessing"
              [pTooltip]="'Default inventory mapping is predefined for each provider based on standardized column ordering.'"
              (click)="openResetToDefaultConfirmation()"
              label="Reset To Default">
            </p-button>
            <p-button label="Save"
                      styleClass="p-button-success p-button-icon"
                      [disabled]="duplicateFields.size > 0 || !inventoryMappingForm.dirty"
                      (click)="updateInventoryMapping()"
                      class="update-mapping-button">
            </p-button>
            <div *ngIf="requestProcessing">
              <p-progressSpinner
                [style]="{'height': '2.5rem'}"
                strokeWidth="8">
              </p-progressSpinner>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  </div>
</p-panel>
<auto-footer></auto-footer>
